export const isEmpty = (text: string = ''): boolean => {
  return getTextContent(text).trim() === '';
};

export const getTextContent = (text: string = ''): string => {
  const tempNode = document.createElement('div');
  // eslint-disable-next-line no-unsanitized/property
  tempNode.innerHTML = text;
  return tempNode.textContent || '';
};
